export const TeamNameFormatter = (teamName) => {
    if (!teamName || typeof teamName !== 'string') {
        return {
            full_name: '',
            shortened_name: '',
            abbreviated_name: ''
        };
    }

    const words = teamName.trim().split(/\s+/);
    const wordCount = words.length;

    let full_name = teamName;
    let shortened_name = '';
    let abbreviated_name = '';

    if (wordCount === 1) {
        // One word: full_name and shortened_name are the same, abbreviated_name is first 3 letters uppercase
        shortened_name = teamName;
        abbreviated_name = words[0].substring(0, 3).toUpperCase();
    } else if (wordCount === 2) {
        // Two words: full_name is same, shortened_name is first word, abbreviated_name is 1st letter of first word + first 2 letters of second word
        // Edge case: if second word is "City" or "United", shortened_name is first 3 letters of first word + second word
        const secondWordLower = words[1].toLowerCase();
        if (secondWordLower === 'city' || secondWordLower === 'united') {
            const secondWordFormatted = secondWordLower === 'united' ? 'Utd' : words[1];
            shortened_name = words[0].substring(0, 3) + ' ' + secondWordFormatted;
        } else {
            shortened_name = words[0];
        }
        abbreviated_name = (words[0].charAt(0) + words[1].substring(0, 2)).toUpperCase();
    } else {
        // Three or more words: full_name is same, shortened_name is first two words, abbreviated_name is 1st letter of each word
        shortened_name = words.slice(0, 2).join(' ');
        abbreviated_name = words.map(word => word.charAt(0)).join('').toUpperCase();
    }

    return {
        full_name,
        shortened_name,
        abbreviated_name
    };
};
